module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "gigs"
    }
  }, [_c('list', {
    ref: "list",
    attrs: {
      "scroll": true,
      "items": _vm.gigs,
      "link": "gig",
      "fields": ['title', 'place', 'date'],
      "type": "std"
    },
    on: {
      "update": _vm.load
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f8c30a9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/webzine/Gigs.vue
// module id = 276
// module chunks = 0